export default class UsuarioEnderecoModel {
  usuarioId: number = 0;
  descricao: string = "";
  enderecoCompleto: string = "";
  endereco: string = "";
  numero: string = "";
  complemento: string = "";
  bairro: string = "";
  cidadeId: number = 0;
  estado: string = "";
  cidadeEstado: string = "";
  cep: number = 0;

  public static toModel(obj: any) : UsuarioEnderecoModel {
    return {
      usuarioId: obj.ClientID,
      enderecoCompleto: obj.CompleteAddress,
      endereco: obj.Address,
      numero: obj.Number,
      complemento: obj.Complement,
      bairro: obj.Neighborhood,
      cidadeId: obj.CityID,
      cidadeEstado: obj.CityAndState,
      cep: obj.ZipCode,
      estado: obj.State,
    } as UsuarioEnderecoModel;
  }
}
